"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomRange = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const Elements_1 = require("./Elements");
const constants_1 = require("../../constants");
const translate_1 = require("../../translate");
const Div_1 = require("../Div");
const DatePicker_1 = require("../Form/DatePicker");
const Icon_1 = require("../Icon");
const Label = styled_1.default.span({
    fontWeight: constants_1.theme.font.weight.book,
    paddingRight: constants_1.theme.spacing[1],
    color: constants_1.Color.DARKEST_MEDIUM_GREY,
});
const CustomRange = (props) => {
    const t = (0, translate_1.useTranslations)();
    return ((0, jsx_runtime_1.jsxs)(Elements_1.RangeUIWrapper, { children: [(0, jsx_runtime_1.jsx)(DatePicker_1.DatePicker, { maxDate: props.endDate, value: props.startDate, onChange: (startDate) => props.onChange({ startDate }), input: (0, jsx_runtime_1.jsxs)(Elements_1.RangeUIButton, { size: "xs", design: "white", styles: { pr: 3, pl: 2.5 }, children: [(0, jsx_runtime_1.jsxs)(Label, { children: [t.form.from(), ":"] }), " ", props.startLabel] }) }), (0, jsx_runtime_1.jsx)(Div_1.Div, { styles: { position: 'relative' }, children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { backgroundColor: constants_1.Color.WHITE, name: "ArrowRightIcon", color: constants_1.Color.DARK_MEDIUM_GREY, size: "sm", styles: {
                        zIndex: 1,
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                    } }) }), (0, jsx_runtime_1.jsx)(DatePicker_1.DatePicker, { minDate: props.startDate, value: props.endDate, onChange: (endDate) => props.onChange({ endDate }), input: (0, jsx_runtime_1.jsxs)(Elements_1.RangeUIButton, { size: "xs", design: "white", styles: {
                        color: props.endDate ? undefined : constants_1.Color.DARK_GREY,
                        pl: 3,
                        pr: 2.5,
                    }, children: [(0, jsx_runtime_1.jsxs)(Label, { children: [t.form.to(), ":"] }), ' ', props.endLabel ?? `${t.form.select_a_date()}...`] }) })] }));
};
exports.CustomRange = CustomRange;
